import React from 'react'
import "./BlogPost.css";

import heroshot from "../../Assets/b55/heroshot.jpg"
import img1 from "../../Assets/b55/img1.jpg"

function Blog55() {
    return (
        <div className='container-fluid my-5'>
            <div className='row mb-5'>
                <div className='col blog-text text-center'>
                    <h1>DreamTech: All-in-One POS Solution for Business Success</h1>
                    <h6>July 23 2024 at 5:52 PM</h6>
                </div>
            </div>

            <div className='row align-items-center justify-content-center mx-5 gx-5 gy-5'>
                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-5 col-xxl-5'>
                    <div id="blogImages" className="carousel carousel-dark slide mx-auto" data-bs-ride="true" data-bs-interval='4000'>
                        <div className="carousel-indicators">
                            <button type="button" data-bs-target="#blogImages" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#blogImages" data-bs-slide-to="1" aria-label="Slide 2"></button>
                        </div>
                        <div className="carousel-inner">
                            <div className="carousel-item active">
                                <img src={heroshot} className="blog-img" alt="..." />
                            </div>
                            <div className="carousel-item">
                                <img src={img1} className="blog-img" alt="..." />
                            </div>
                        </div>
                        <button className="carousel-control-prev" type="button" data-bs-target="#blogImages" data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>
                        <button className="carousel-control-next" type="button" data-bs-target="#blogImages" data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>
                </div>
                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 blog-text'>
                    <p>DreamTech, our BIR-registered software and hardware POS solutions will help you optimize your business operations. Whether you need a standalone, multiterminal, or mobile setup, our POS solutions guarantee accuracy and compliance at every step.</p>
                    <p>Contact us today to see how it works!</p>
                    <p><a href='https://www.facebook.com/hashtag/dreamtechpos' target='_blank' className='blog-link'>
                        #DreamTechPOS </a>
                        <a href='https://www.facebook.com/hashtag/pointofsale' target='_blank' className='blog-link'>
                        #PointofSale </a>
                        <a href='https://www.facebook.com/hashtag/smarttools' target='_blank' className='blog-link'>
                        #SmartTools </a>
                        <a href='https://www.facebook.com/hashtag/godigital' target='_blank' className='blog-link'>
                        #GoDigital </a>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Blog55
